import { Injectable, inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PartnerFormRequest, PartnerFormResponse } from '../models/partner-form';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PartnersApplicationService {
  private readonly API_URL = '/partners-application/technical-visits';
  private apiService = inject(ApiService);

  submitPartnerForm(
    payload: PartnerFormRequest
  ): Observable<PartnerFormResponse> {
    const headers = new HttpHeaders({
      'X-API-Key': environment.apiKey,
      'Content-Type': 'application/json',
    });
    
    return this.apiService.post<PartnerFormResponse>(
      this.API_URL,
      payload,
      { headers }
    );
  }
}
